import { adminAPIService } from './index'

const route = 'display-hardcode'

export default {
  getList({ page = 1, size = 50 }) {
    const params = { page, size }
    return adminAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
  getDetail(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  update(detail, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  create(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
}
